'use strict';

bbw.model.Abuse = ngtk.model.Item.extend({

    statics: {
        REASON_PHOTO: 'photo',
        REASON_FLOOD: 'flood',
        REASON_RUDE: 'rude',
        REASON_HARRASMENT: 'harrasment',
        REASON_SPAM: 'spam',
        REASON_OTHER: 'other',
        REASONS: { // : has_desc
            'flood': false,
            'photo': false,
            'rude': false,
            'harrasment': false,
            'spam': false,
            'other': true
        },
        REASONS_LIST: [
            {reason: 'flood', contexts: ['thread']},
            {reason: 'photo', contexts: ['post', 'profile', 'thread']},
            {reason: 'harrasment'},
            {reason: 'rude'},
            {reason: 'spam'},
            {reason: 'other', has_desc: true}
        ],
        getReasonsList: function(contextName) {
            if (angular.isUndefined(contextName)) {
                return bbw.model.Abuse.REASONS_LIST;
            }
            return bbw.model.Abuse.REASONS_LIST.filter(function(reason) {
                return !angular.isArray(reason.contexts) || reason.contexts.indexOf(contextName) >= 0;
            });
        },
        requiresDesc: function(r) {
            return bbw.model.Abuse.REASONS[r];
        }
    },

    _initialize: function() {
        this._data = {
            reason: null,
            desc: ''
        };
    },

    setReason: function(reason, desc) {
        if (angular.isUndefined(bbw.model.Abuse.REASONS)) {
            throw new Error("Invalid argument: reason");
        }
        var hasDesc = bbw.model.Abuse.REASONS[reason];
        if (hasDesc) {
            if (!desc) {
                throw new Error("Invalid argument: desc is empty, but required for reason: " + reason);
            }
        } else {
            desc = null;
        }
        this._data.reason = reason;
        this._data.desc = desc;

        return this;
    },

    getReasons: function() {
        return bbw.model.Abuse.REASONS;
    },

    getReason: function() {
        return this._data.reason;
    },

    getDesc: function() {
        return this._data.desc;
    }

});